
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const BatteryLowIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25.5 34C23.567 34 22 35.567 22 37.5V58.5C22 60.433 23.567 62 25.5 62H30.5C32.433 62 34 60.433 34 58.5V37.5C34 35.567 32.433 34 30.5 34H25.5Z" fill="#161617"/>
<path fillRule="evenodd" clipRule="evenodd" d="M8 30.5C8 24.701 12.701 20 18.5 20H73.5C79.299 20 84 24.701 84 30.5V38.1497C86.296 38.7105 88 40.7813 88 43.25V52.75C88 55.2187 86.296 57.2895 84 57.8503V65.5C84 71.299 79.299 76 73.5 76H18.5C12.701 76 8 71.299 8 65.5V30.5ZM77 30.5V65.5C77 67.433 75.433 69 73.5 69H18.5C16.567 69 15 67.433 15 65.5V30.5C15 28.567 16.567 27 18.5 27H73.5C75.433 27 77 28.567 77 30.5Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.5 23.5C14.634 23.5 11.5 26.634 11.5 30.5V65.5C11.5 69.366 14.634 72.5 18.5 72.5H73.5C77.366 72.5 80.5 69.366 80.5 65.5V54.5H82.75C83.7165 54.5 84.5 53.7165 84.5 52.75V43.25C84.5 42.2835 83.7165 41.5 82.75 41.5H80.5V30.5C80.5 26.634 77.366 23.5 73.5 23.5H18.5Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M70.5 34C72.433 34 74 35.567 74 37.5V58.5C74 60.433 72.433 62 70.5 62H65.5C63.567 62 62 60.433 62 58.5V37.5C62 35.567 63.567 34 65.5 34H70.5Z" fill="#161617"/>
<path fillRule="evenodd" clipRule="evenodd" d="M88 30.5C88 24.701 83.299 20 77.5 20H22.5C16.701 20 12 24.701 12 30.5V38.1497C9.70399 38.7105 8 40.7813 8 43.25V52.75C8 55.2187 9.70399 57.2895 12 57.8503V65.5C12 71.299 16.701 76 22.5 76H77.5C83.299 76 88 71.299 88 65.5V30.5ZM19 30.5V65.5C19 67.433 20.567 69 22.5 69H77.5C79.433 69 81 67.433 81 65.5V30.5C81 28.567 79.433 27 77.5 27H22.5C20.567 27 19 28.567 19 30.5Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M77.5 23.5C81.366 23.5 84.5 26.634 84.5 30.5V65.5C84.5 69.366 81.366 72.5 77.5 72.5H22.5C18.634 72.5 15.5 69.366 15.5 65.5V54.5H13.25C12.2835 54.5 11.5 53.7165 11.5 52.75V43.25C11.5 42.2835 12.2835 41.5 13.25 41.5H15.5V30.5C15.5 26.634 18.634 23.5 22.5 23.5H77.5Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
